export default __webpack_public_path__ + "static/media/storytelling.bad03626.svg";